import {Redirect} from 'react-router-dom'
import {Component} from 'react'
import Cookies from 'js-cookie'
import './index.css'

class LoginForm extends Component {
  state = {username: '', password: '', showErrMsg: '', ErrMsgStatus: false}

  onChangeUsername = event => {
    this.setState({
      username: event.target.value,
    })
  }

  onChangePassword = event => {
    this.setState({
      password: event.target.value,
    })
  }

  onSubmitSuccess = jwtToken => {
    const {history} = this.props
    Cookies.set('jwt_token', jwtToken, {expires: 30})
    history.replace('/')
  }

  onFailure = errMsg => {
    this.setState({
      ErrMsgStatus: true,
      showErrMsg: errMsg,
    })
  }

  onSubmitButton = async event => {
    event.preventDefault()
    const {username, password} = this.state
    const userDetails = {username, password}
    const apiUrl = ' https://apis.ccbp.in/login'
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }

    const response = await fetch(apiUrl, options)
    const data = await response.json()
    if (response.ok === true) {
      this.onSubmitSuccess(data.jwt_token)
    } else {
      this.onFailure(data.error_msg)
    }
  }

  render() {
    const {showErrMsg, ErrMsgStatus} = this.state
    const jwtToken = Cookies.get('jwt_token')

    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }
    return (
      <div className="login-container">
        <div className="form-main-container">
          <img
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png "
            alt="website logo"
            className="website-logo-img"
          />
          <form className="form-container" onSubmit={this.onSubmitButton}>
            <label htmlFor="username" className="labels">
              USERNAME
            </label>

            <input
              type="text"
              id="username"
              placeholder="Username"
              className="inputs"
              onChange={this.onChangeUsername}
            />
            <br />
            <label htmlFor="password" className="labels">
              PASSWORD
            </label>

            <input
              type="password"
              placeholder="Password"
              id="password"
              className="inputs"
              onChange={this.onChangePassword}
            />
            <br />
            <button type="submit" className="login-button">
              Login
            </button>
            {ErrMsgStatus ? <p className="error-msg">*{showErrMsg}</p> : null}
          </form>
        </div>
      </div>
    )
  }
}

export default LoginForm
